   
                        
  
                                                  
                          
   

import Watcher from './watcher';
import Utilities from "../util/utilities";

let uid = 0;

   
                     
   
export default class Dispatcher {
     
                
                             
                                  
     
  constructor (app, watchers = []) {
    this.id = ++uid;
    this.watchers = watchers;
    this.app = app;
  }

     
                 
                             
     
  attach (watcher) {
    this.watchers.push(watcher);
  }

     
                    
                             
                          
     
  detach (watcher) {
    Utilities.removeElement(this.watchers, watcher);

    watcher.removeDispatcher();

    return this;
  }

     
                                    
     
  attachCurrent () {
    if (this.app.currentWatcher) {
      this.app.currentWatcher.addDispatcher(this);
    }
  }

     
                                              
    
                         
     
  notify (ctrl = undefined) {
    this.watchers.forEach(watcher => watcher.update(ctrl));
  }
}



// WEBPACK FOOTER //
// ./src/observer/dispatcher.js